import { IValidationToastNotification, Routes } from '../../common';
import { getAppendingNumericIdFromUrl } from '../../utils';
import { getErrorMessageForError } from './ErrorMessageMapper';
import { useUnifiedNavigate } from '@common/hooks/useUnifiedNavigation';
import { MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

export interface IVehicleUnavailableNotificationNotificationProps extends IValidationToastNotification {
  errorCode: number;
  orderId?: string;
}

export const VehicleUnavailableNotification = ({
  errorCode,
  orderId,
  severityLevel = TMessageBarSeverity.ERROR,
  onClose,
}: IVehicleUnavailableNotificationNotificationProps) => {
  const getOrderId = () => orderId || getAppendingNumericIdFromUrl('');
  const router = useUnifiedNavigate();
  //TBD: ServiceNowTicket Creation. Currently moves to View Page
  const raiseServiceNowIncident = async () => {
    const route = Routes.getViewPage(getOrderId());
    router(route);
  };

  return (
    <MessageBar severity={severityLevel} onClose={onClose} dismissible className="max-w-1/3">
      <h4 className="text-lg/[175%]">Manglende kjøretøydata</h4>
      <p className="text-base/[175%] font-semibold">{getErrorMessageForError(errorCode)}</p>
      {getOrderId() && (
        <a
          className="text-base/[175%] font-semibold underline cursor-pointer"
          onClick={() => raiseServiceNowIncident()}
        >
          Rapporter her
        </a>
      )}
    </MessageBar>
  );
};
